import CanvasObject, {BoundingBox} from './CanvasObject.js';

export default class KeyframeObject extends CanvasObject {

  constructor(parent, time, x, y, width, height, color) {
    super(parent, {x, y, width, height, draggable: false, type: 'custom'}, {}, {'skipMeForNearObjs': true});
    this.color = color;
    this.time = time;
    this.showTime = false;
    this.boundingBox = new BoundingBox(this, {offsets: {x: -5, y: -5}});
    this.init();
  }

  init() {
    this.on('focus', (e) => {
      this.showTime = true;
    })
    this.on('unfocus', (e) => {
      this.showTime = false;
    })
  }

  updateTime(time) {
    this.time = time;
  }

  draw(context) {
    context.save();
    context.globalCompositeOperation = 'source-over'
    context.fillStyle = this.color;
    context.beginPath();
    context.translate(this.x, this.y);
    context.rotate(Math.PI / 4);
    context.fillRect(-this.width / 2, -this.height / 2, this.width, this.height);
    context.restore();

    if(this.showTime) {
      context.font = '14px Microsoft Yi Baiti'
      context.strokeStyle = '#2E3440';
      context.fillStyle = 'white';
      context.lineWidth = 3;
      context.textAlign = "center";

      context.fillText(this.time / 1000 + 's', this.x, this.y - 15);
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/canvas/objects/KeyframeObject.js